import React from 'react';
import ordersReducer from '../../reducers/ordersReducer';

interface HighlightedShortIdProps {
  orderShortId: string;
  headingLevel?: keyof JSX.IntrinsicElements;
}

const HighlightedShortId = ({ orderShortId, headingLevel = 'h6' }: HighlightedShortIdProps) => {
  return React.createElement(
    headingLevel,
    { className: 'flex items-center text-2xl font-semibold' },
    orderShortId?.split('').map((char, index) => (
      <span key={`${ordersReducer}-${char}-${index}`} className={index >= 4 ? 'text-red-500' : ''}>
        {char}
      </span>
    ))
  );
};

export default HighlightedShortId;
